import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IMyApprovals } from '../Interfaces/IMyApprovals';

@Injectable({
  providedIn: 'root',
})
export class MyApprovalsService extends RestCallService {
  
  dataToSend: IMyApprovals = {
    pkvisitbyvisitor: 0,
    pkvisit: 0,
    pkvisitor: 0,
    visitorname: '',
    email: '',
    phone: '',
    position: '',
    creationdate: new Date(),
    strcreationdate: '',
    lastupdated: new Date(),
    strlastupdated: '',
    username: '',
    fksite: 0,visittype: '',
    sponsor: '',
    sponsorname: '',
    startdatevisit: new Date(),
    strstartdatevisit: '',
    enddatevisit: new Date(),
    strenddatevisit: '',
    fkbuilding: 0,
    building: '',
    activity: '',
    areaproject: '',
    supplierincometype: '',
    companysupplier: '',
    sitetovisit: '',
    buildingtovisit: '',
    visitorphoto: '',
    visitorphotoid: '',
    visitorid: '',
    starthour: '',
    endhour: '',
    temporarybadge: false,
    description: '',
    startofwork: false,
    critical_work: false,
    foreignvisit: false,
    employeecreatorname: '',
    employeeupdatername: '',
    requisitionIDPO: '',
    badge: '',
    emergencycontactname: '',
    emergencycontactnumber: '',
    flight: '',
    foodrestriction: '',
    hotelinformation: '',
    originsite: '',
    originbuilding: '',
    workday: '',
    listPkVisitByVisitor: [],
    approval_order: 0,
    fk_approver_area: 0,
    fk_visitor_by_visit: 0,
    fkApprover: 0,
    approverarea: '',
    approval_comment: ''
  }

  constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
  }
  
  public ApproveVisitByVisitor(data: number[], fk_visitor_by_visit: number, fk_approver_area: number, fkApprover: number) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.fk_visitor_by_visit = fk_visitor_by_visit;
    this.dataToSend.fk_approver_area = fk_approver_area;
    this.dataToSend.fkApprover = fkApprover;
    this.dataToSend.listPkVisitByVisitor = data;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<boolean>('/api/MyApprovals/ApproveVisitByVisitor', this.dataToSend);
  }

  public GetMyApprovals() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<IMyApprovals[]>('/api/MyApprovals/GetMyApprovals', this.dataToSend);
  }

  public RejectVisitByVisitor(fk_visitor_by_visit: number, fk_approver_area: number, fkApprover: number, rejectcomment: string) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.fk_visitor_by_visit = fk_visitor_by_visit;
    this.dataToSend.fk_approver_area = fk_approver_area;
    this.dataToSend.fkApprover = fkApprover;
    this.dataToSend.approval_comment = rejectcomment;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<boolean>('/api/MyApprovals/RejectVisitByVisitor', this.dataToSend);
  }

  public RedirectToSubcontracting(data: number) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
  
    this.dataToSend.fk_visitor_by_visit = data;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<boolean>('/api/MyApprovals/RedirectToSubcontracting', this.dataToSend);
  }

  GetApprovalAreasByUser() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<IMyApprovals[]>('/api/MyApprovals/GetApprovalAreasByUser', this.dataToSend);
  }
}